import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import moment from 'moment';
import {Text} from './OpeningTimes.style';

const OpeningTimes = ({
  isOpenForCollectionOrDelivery,
  openingTimesContent,
  isOpensInSevenDays
}) => {
  return (
    <div>
      {!isOpenForCollectionOrDelivery && <FormattedMessage id={isOpensInSevenDays ? 'home.restaurant.openNext' : 'home.restaurant.openOn'} />}
      <Text>{isOpensInSevenDays ? moment(openingTimesContent.from).format('ddd') : moment(openingTimesContent.from).format('D/MM/YY')}</Text>
      <span>{moment(openingTimesContent.from).format('h:mm a')}</span> - <span>{moment(openingTimesContent.to).format('h:mm a')}</span>
    </div>
  );
};

OpeningTimes.propTypes = {
  isOpenForCollectionOrDelivery: PropTypes.bool.isRequired,
  openingTimesContent: PropTypes.object.isRequired,
  isOpensInSevenDays: PropTypes.bool.isRequired
};

export default OpeningTimes;



// WEBPACK FOOTER //
// ./containers/HomePage/OpeningTimes.js